"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentPurpose = void 0;
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const types_1 = require("../../types");
const styles_1 = require("../styles");
const utils_1 = require("../lib/utils");
const messages_1 = require("../lib/messages");
exports.AppointmentPurpose = (0, intl_1.injectIntl)(({ initialPurpose, intl, onChange, purpose, purposeOptionsByRelationship, relationship, visitMethodGroup }) => {
    const [purposesChanged, setPurposesChanged] = (0, react_1.useState)(false);
    const purposeOptions = (0, utils_1.getVisitMethodGroupOptions)(purposeOptionsByRelationship, relationship, visitMethodGroup);
    // toggle transitioning state help the user identify that the
    // purpose list has been updated
    (0, react_1.useEffect)(() => {
        setPurposesChanged(true);
        const timeout = setTimeout(() => {
            setPurposesChanged(false);
        }, 1000);
        return () => clearTimeout(timeout);
    }, [relationship, visitMethodGroup]);
    return (react_1.default.createElement(styles_1.AppointmentPurposeSelect, { key: purpose, id: "appt-info-purpose", label: intl.formatMessage(messages_1.messages.appointmentPurposeLabel), placeholder: intl.formatMessage(messages_1.messages.appointmentPurposePlaceholder), items: purposeOptions, itemToString: (option) => {
            if (option) {
                const visitMethodLabel = intl.formatMessage((0, utils_1.getVisitMethodMessage)(option.visit_method));
                return option.visit_method !== types_1.VisitType.IN_PERSON
                    ? `${option.name} - ${visitMethodLabel}`
                    : option.name;
            }
            else {
                // appease the linter. if purpose is cleared between renders (e.g. if default purpose is disabled
                // via config and user changes relationship), option can be null between renders
                return '';
            }
        }, maxHeight: 200, selectedItem: purpose, initialSelectedItem: initialPurpose, onChange: (o) => onChange(o), inputProps: {
            'data-testid': 'appt-info-purpose',
            className: purposesChanged ? 'changed' : ''
        } }));
});
//# sourceMappingURL=AppointmentPurpose.js.map